import { render, staticRenderFns } from "./images-controller.vue?vue&type=template&id=094dc028&scoped=true&"
import script from "./images-controller.vue?vue&type=script&lang=js&"
export * from "./images-controller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094dc028",
  null
  
)

export default component.exports